export default __webpack_public_path__ + "static/media/8.60cb7869.png";